import { Link } from "react-router-dom";

/**
 * Fiduciaire Bleich logo.
 * Two real image variants are shipped:
 *  - `dark`  → /logo-fiduciaire-bleich.png        (transparent bg, original colours)
 *  - `light` → /logo-fiduciaire-bleich-white.png  (monochrome white for dark footer)
 */
export const Logo = ({ variant = "dark", className = "", size = "md" }) => {
    const sizes = {
        sm: "h-12",                  // ~48px — footer
        md: "h-16",                  // ~64px
        lg: "h-20",                  // ~80px
        xl: "h-16 md:h-24",          // ~64px mobile / ~96px desktop — header
    };

    const src =
        variant === "light"
            ? "/logo-fiduciaire-bleich-white.png"
            : "/logo-fiduciaire-bleich.png";

    return (
        <Link
            to="/"
            data-testid="site-logo"
            aria-label="Fiduciaire Bleich — Accueil"
            className={`inline-flex items-center group ${className}`}
        >
            <img
                src={src}
                alt="Fiduciaire Bleich"
                className={`${sizes[size]} w-auto object-contain transition-opacity duration-200 group-hover:opacity-85`}
                draggable="false"
            />
        </Link>
    );
};

export default Logo;
